import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { FilterKeys } from '../../../../../shared/projectsV2/filters';
import * as ProjectsV2Store from '../../../../redux/projectsV2';
import { FilterPanel } from '../../../generic/Filter';
import FilterCardRadios from '../../../generic/Filter/FilterCardRadios';
import useFetchProjectsAction from '../hooks/useFetchProjectsAction';
import type { SelectOption } from '../../../../types';

const FILTER_OPTIONS: SelectOption[] = [
  { value: 'any', label: 'Anytime' },
  { value: '7', label: 'Last 7 days' },
  { value: '30', label: 'Last 30 days' },
  { value: '120', label: 'Last 120 days' },
];

const ageToValue = (age?: number): string => {
  if (age === undefined) {
    return 'any';
  }
  return String(age);
};

const Scanned: VoidFunctionComponent = () => {
  const filter = useSelector(ProjectsV2Store.selectors.getFilter);
  const setFilter = useFetchProjectsAction(ProjectsV2Store.actions.setFilter);

  const onChange = (value: string) => {
    if (Number(value)) {
      setFilter({ ...filter, [FilterKeys.LatestScan]: Number(value) });
    } else {
      setFilter({ ...filter, [FilterKeys.LatestScan]: undefined });
    }
  };

  return (
    <FilterPanel>
      <FilterCardRadios
        label="Last policy scan"
        options={FILTER_OPTIONS}
        value={ageToValue(filter.latestScan)}
        onChange={onChange}
      />
    </FilterPanel>
  );
};

export default Scanned;
